module.exports = __webpack_public_path__ + "img/crizal-alize.5b3a7f9e.svg";